// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3qhp_","title":"AfterBackImages_title__3Qtpo","images":"AfterBackImages_images__3-7s8"};